import React from 'react';

import BomForm from './bom_form';

const BomHeader = (props) => {
  const { name, revision, board_qtys, header, first_row, validator } = props;

  return (
    <div className='bom-header'>
      <div className='container-fluid'>
        <BomForm
          name={name}
          revision={revision}
          board_qtys={board_qtys}
          header={header}
          first_row={first_row}
          validator={validator} />
      </div>
    </div>
  );
};

export default BomHeader;
